// extracted by mini-css-extract-plugin
export default {"checkbox":"switcher_tel_list_checkbox__MXGfy","label":"switcher_tel_list_label__mOmi6","button":"switcher_tel_list_button__qa78u"};